import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { IconCalendar, IconClock } from '@tabler/icons';
import moment from 'moment';
import { FC } from 'react';

const DateColumn: FC<{
	date: string;
	withTime?: boolean;
	withDayDate?: boolean;
}> = ({ date, withTime = false, withDayDate = true }) => {
	const momentDate = moment(date);

	return (
		<Tooltip
			placement='top-start'
			arrow
			title={momentDate.format('ddd MMMM Do YYYY, h:mm a')}
		>
			<Stack justifyContent={'start'} alignItems={'start'}>
				<Chip label={momentDate.fromNow()} size={'small'} />
				{withDayDate && (
					<Stack
						alignItems={'center'}
						justifyContent={'center'}
						flexDirection={'row'}
						paddingY={1}
					>
						<IconCalendar color='gray' />
						<Stack sx={{ pl: 1, pt: 0.4 }}>
							<Typography>{momentDate.format('MM/DD/YYYY')}</Typography>
						</Stack>
					</Stack>
				)}
				{withTime && (
					<Stack alignItems={'center'} flexDirection={'row'}>
						<IconClock color='gray' />
						<Typography sx={{ pl: 1 }}>
							{momentDate.format('h:mm a')}
						</Typography>
					</Stack>
				)}
			</Stack>
		</Tooltip>
	);
};

export default DateColumn;
